import { render, staticRenderFns } from "./PCProgramming.vue?vue&type=template&id=a91ec8c6&scoped=true&lang=pug&"
import script from "./PCProgramming.vue?vue&type=script&lang=js&"
export * from "./PCProgramming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91ec8c6",
  null
  
)

export default component.exports